module.exports = __webpack_public_path__ + "static/media/car6.0492e367.png";